import React, { Component, useState, Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';


import Cookies from 'js-cookie'
import settings from '../../settings.json';


export default class Header extends Component{
  state={

  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount () {
    //fetch(`https://api.hello-remix.com/check_updated_at/?token=bb7773835859debab60572f21dbaf133c09ef6d16d970aa8ac921038946e7b3a&name=%E5%A4%A7%E5%B3%B6&type=inventory&val=updated_at`)
    //  .then(res => res.json())
    //  .then(json => console.log('OK'));

		let staff_name = Cookies.get('_replace_staff');
		this.setState({staff_name:staff_name});

		let staff_token = Cookies.get('_replace_token');
		let auth_obj = {"name":staff_name, "token":staff_token};

  }

	componentWillUnmount() {
    
  }



  
  render(){
    return (
      <header className="row align-item-center logo-area">
				<div className="row small align-item-center">
					<div className="col-1 logo-area" ><a href="/orverseas"><img className="top-logo" src={"./images/logo192.jpg"} /></a></div>
					<div className="col-1"></div>
					<div className="col-8"></div>
				</div>

      </header>
    );
  }
}